module.factory('cardOrderService', ['$http', 'baseURI', 'Transform', function($http, baseURI, Transform) {

  var cards = [];
  var currentCardIndex;

  var service = {
    addCard: addCard,
    getCards: getCards,
    loadCards: loadCards,
    createCard: createCard,
    setCurrentCardIndex: setCurrentCardIndex,
    getCurrentCard: getCurrentCard
  };

  return service;

  function createCard(firstName, lastName, virtual) {
    cards.push({
      'CardPurpose': 'personal',
      'ATMInternationalAccess': true,
      'FirstName': firstName,
      'LastName': lastName,
      'Virtual': false
    });
    currentCardIndex = cards.length - 1;
  }

  function setCurrentCardIndex(index) {
    currentCardIndex = index;
  }

  function getCurrentCard() {
    if (currentCardIndex === undefined) {
      return cards[cards.length - 1];
    } else {
      return cards[currentCardIndex];
    }
  }

  function addCard(card, postFlag) {
    var method = 'POST';
    var orderURL = 'reloadable-card/order';
    // If card has CardOrderItemId it means that it's already in the server
    // We use the PUT method to edit the card instead of adding it
    if (!postFlag) {
      method = 'PUT';
      orderURL = 'reloadable-card/order/'+card.CardOrderItemId;
    }

    $http({
      url: baseURI + orderURL,
      method: method,
      headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
      data: Transform.encode(card)
    }).catch(function (error){
      console.log(error);
    });
  }

  function getCards() {
    return cards;
  }

  function loadCards() {
    return $http({
      url: baseURI + 'reloadable-card/order',
      method: 'GET',
      headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'}
    }).then(function(result) {
      cards = result.data.Data;
      return result.data.Data;
    });
  }

}]);
